import{a as L}from"./ids-chunk-ETSNT6ZD.js";import{a as m}from"./ids-chunk-CMTTSJWO.js";import{a as p}from"./ids-chunk-3DA43NO3.js";import{a as v}from"./ids-chunk-ZE7KS3QK.js";import{a as g,b as f}from"./ids-chunk-XE4WFW5M.js";import{a as A}from"./ids-chunk-EV6LM7KM.js";import{m as u}from"./ids-chunk-U4XVR5SW.js";import{e as r}from"./ids-chunk-5Q3WPKMB.js";import{a as e}from"./ids-chunk-4O5N6MTO.js";import{a as b,b as x,d as l,g as o}from"./ids-chunk-Y32WUP63.js";var T=`/* Ids Text Component */
:host([overflow=ellipsis]) {
  max-width: 100%;
  display: block;
}

.ids-text {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: var(--ids-font-family-default);
  font-weight: var(--ids-font-weight-normal);
  display: block;
  margin: 0;
  color: currentColor;
  font-size: var(--ids-font-size-40);
  text-decoration: unset;
}
.ids-text.audible {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  position: none;
}
.ids-text.error {
  color: var(--ids-color-text-error);
}
.ids-text.label {
  color: var(--ids-color-text-label);
}
.ids-text.label.color-variant-alternate {
  color: var(--ids-color-text-inverse);
}
.ids-text.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ids-text.has-line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
}
.ids-text.bold {
  font-weight: var(--ids-font-weight-bold);
}
.ids-text.semi-bold {
  font-weight: var(--ids-font-weight-semibold);
}
.ids-text.lighter {
  font-weight: var(--ids-font-weight-light);
}
.ids-text.text-align-start {
  text-align: start;
}
.ids-text.text-align-end {
  text-align: end;
}
.ids-text.text-align-center {
  text-align: center;
}
.ids-text.text-align-justify {
  text-align: justify;
}
.ids-text.status-gray::before, .ids-text.status-error::before, .ids-text.status-info::before, .ids-text.status-success::before, .ids-text.status-warning::before {
  display: inline-flex;
  margin-inline-end: var(--ids-input-margin-bottom);
  border-radius: var(--ids-border-radius-circle);
  content: "";
  height: 8px;
  width: 8px;
}
.ids-text.status-gray {
  color: var(--ids-color-text-label);
}
.ids-text.status-gray::before {
  background-color: var(--ids-color-text-label);
}
.ids-text.status-error {
  color: var(--ids-color-text-error);
}
.ids-text.status-error::before {
  background-color: var(--ids-color-text-error);
}
.ids-text.status-info {
  color: var(--ids-color-text-info);
}
.ids-text.status-info::before {
  background-color: var(--ids-color-text-info);
}
.ids-text.status-success {
  color: var(--ids-color-text-success);
}
.ids-text.status-success::before {
  background-color: var(--ids-color-text-success);
}
.ids-text.status-warning {
  color: var(--ids-color-text-warning);
}
.ids-text.status-warning::before {
  background-color: var(--ids-color-text-warning);
}

:host(.inline) .ids-text {
  display: inline;
}

.inline,
[display=inline] {
  display: inline;
}

.ids-text-color-unset {
  color: unset;
}

:host(.message-text) .ids-text {
  color: unset;
}
:host(.message-text) .ids-text.error {
  color: unset;
}

::slotted(.highlight) {
  font-weight: var(--ids-font-weight-bold);
}

::slotted(.audible) {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

::slotted(.filter) {
  font-weight: var(--ids-font-weight-bold);
}

::slotted(ids-icon) {
  margin: var(--ids-text-icon-margin);
  vertical-align: text-bottom;
}

::slotted(ids-alert) {
  margin: var(--ids-text-alert-margin);
  vertical-align: sub;
}

/* Ids Typography System */
.ids-text-10 {
  font-size: var(--ids-font-size-10);
  text-transform: uppercase;
}

.ids-text-12 {
  font-size: var(--ids-font-size-20);
  text-transform: uppercase;
}

.ids-text-14 {
  font-size: var(--ids-font-size-30);
}

.ids-text-16 {
  font-size: var(--ids-font-size-40);
}

.ids-text-20 {
  font-size: var(--ids-font-size-50);
}

.ids-text-24 {
  font-size: var(--ids-font-size-60);
}

.ids-text-28 {
  font-size: var(--ids-font-size-70);
}

.ids-text-32 {
  font-size: var(--ids-font-size-80);
}

.ids-text-40 {
  font-size: var(--ids-font-size-90);
}

.ids-text-48 {
  font-size: var(--ids-font-size-100);
}

.ids-text-60 {
  font-size: var(--ids-font-size-110);
}

.ids-text-72 {
  font-size: var(--ids-font-size-120);
  margin-block-end: 0;
}

.ids-text-color-muted.ids-text,
:host([disabled]) .ids-text {
  color: var(--ids-color-text-disabled);
}
.ids-text-color-muted.ids-text.label,
:host([disabled]) .ids-text.label {
  color: var(--ids-color-text-disabled);
}
.ids-text-color-muted.ids-text.color-variant-alternate.label,
:host([disabled]) .ids-text.color-variant-alternate.label {
  color: var(--ids-color-text-subtle);
}
.ids-text-color-muted.ids-text.status-base, .ids-text-color-muted.ids-text.status-error, .ids-text-color-muted.ids-text.status-info, .ids-text-color-muted.ids-text.status-success, .ids-text-color-muted.ids-text.status-warning,
:host([disabled]) .ids-text.status-base,
:host([disabled]) .ids-text.status-error,
:host([disabled]) .ids-text.status-info,
:host([disabled]) .ids-text.status-success,
:host([disabled]) .ids-text.status-warning {
  color: var(--ids-color-text-disabled);
}
.ids-text-color-muted.ids-text.status-error::before, .ids-text-color-muted.ids-text.status-info::before, .ids-text-color-muted.ids-text.status-success::before, .ids-text-color-muted.ids-text.status-warning::before,
:host([disabled]) .ids-text.status-error::before,
:host([disabled]) .ids-text.status-info::before,
:host([disabled]) .ids-text.status-success::before,
:host([disabled]) .ids-text.status-warning::before {
  background-color: var(--ids-color-text-disabled);
}

:host([class=label-checkbox]) .audible {
  position: relative;
  line-height: 1;
  height: unset;
}

::slotted(ids-badge) {
  position: relative;
  margin-inline-start: 8px;
  top: 1px;
  vertical-align: top;
}`;var E=["bold","semi-bold","lighter"],y=["label","legend","span"],w=["start","end","center","justify"],C=["base","error","info","success","warning"],z=[{10:"10px"},{12:"12px"},{14:"14px"},{16:"16px"},{20:"20px"},{24:"24px"},{28:"28px"},{32:"32px"},{40:"40px"},{48:"48px"},{60:"60px"},{72:"72px"}],O=v(m(L(p(A)))),c,I,h,S,n,d,a=class extends O{constructor(){super();l(this,c);l(this,h);l(this,n);x(this,"colorVariants",["alternate"])}connectedCallback(){super.connectedCallback(),o(this,c,I).call(this),this.color&&(this.color=this.getAttribute("color"))}static get attributes(){return[...super.attributes,e.AUDIBLE,e.COLOR,e.DATA,e.DISABLED,e.DISPLAY,e.ERROR,e.FONT_SIZE,e.FONT_WEIGHT,e.LABEL,e.LINE_CLAMP,e.MAX_WIDTH,e.OVERFLOW,e.STATUS,e.TEXT_ALIGN,e.TRANSLATE_TEXT,e.TYPE]}template(){let t=this.type||"span",s=this.fontWeight,i="ids-text";return i+=this.status?` ${this.statusClass()}`:"",i+=this.textAlign?` ${this.textAlignClass()}`:"",i+=this.overflow==="ellipsis"?" ellipsis":"",i+=this.audible?" audible":"",i+=this.label?" label":"",i+=this.fontSize?` ids-text-${this.fontSize}`:"",i+=s==="bold"||s==="lighter"||s==="semi-bold"?` ${this.fontWeight}`:"",`<${t}
      class="${i}"
      part="text"
    ><slot></slot>
    </${t}>`}set fontSize(t){t?this.setAttribute(e.FONT_SIZE,`${t}`):this.removeAttribute(e.FONT_SIZE),this.container&&(z?.forEach(s=>{this.container?.classList.remove(`ids-text-${Object.keys(s)}`)}),t&&this.container.classList.add(`ids-text-${t}`))}get fontSize(){return this.getAttribute(e.FONT_SIZE)}set fontWeight(t){this.container?.classList.remove(...E),t&&E.includes(t)?(this.setAttribute(e.FONT_WEIGHT,t),this.container?.classList.add(t)):this.removeAttribute(e.FONT_WEIGHT)}get fontWeight(){return this.getAttribute(e.FONT_WEIGHT)}set type(t){t?this.setAttribute(e.TYPE,t):this.removeAttribute(e.TYPE),this.render(!0),o(this,h,S).call(this,t??"")}get type(){return this.getAttribute(e.TYPE)}set color(t){let s="ids-text-color-unset",i="ids-text-color-muted";if(this.container?.classList.remove(s,i),typeof t=="string"&&t!==""){this.setAttribute(e.COLOR,t),t==="unset"?(this.container?.classList.add(s),this.container?.style.removeProperty("color")):t==="muted"?(this.setAttribute(e.COLOR,t),this.container?.classList.add(i)):this.container?.style.setProperty("color",`var(--ids-color-${t})`);return}this.removeAttribute(e.COLOR)}get color(){return this.getAttribute(e.COLOR)}set audible(t){r(t)?(this.setAttribute(e.AUDIBLE,t.toString()),this.container&&!this.container.classList.contains(e.AUDIBLE)&&this.container.classList.add("audible")):(this.removeAttribute(e.AUDIBLE),this.container?.classList.remove("audible"))}get audible(){return r(this.getAttribute(e.AUDIBLE))}set disabled(t){this.toggleAttribute(e.DISABLED,r(t))}get disabled(){return r(this.getAttribute(e.DISABLED))}set error(t){let s=r(t);if(s){this.container&&this.container.classList.add("error"),this.setAttribute(e.ERROR,s.toString());return}this.removeAttribute(e.ERROR),this.container&&this.container.classList.remove("error")}get error(){return r(this.getAttribute(e.ERROR))}set label(t){let s=r(t);if(s){this.setAttribute(e.LABEL,s.toString()),this.container?.classList.add("label");return}this.removeAttribute(e.LABEL),this.container&&this.container.classList.remove("label")}get label(){return r(this.getAttribute(e.LABEL))}set data(t){let s=r(t);if(s){this.container?.classList.add("data"),this.setAttribute(e.DATA,s.toString());return}this.removeAttribute(e.DATA),this.container?.classList.remove("data")}get data(){return r(this.getAttribute(e.DATA))}set maxWidth(t){t?(this.setAttribute(e.MAX_WIDTH,t),this.container?.style.setProperty("max-width",`${parseInt(t)}px`,"important")):(this.removeAttribute(e.MAX_WIDTH),this.container?.style.removeProperty("max-width"))}get maxWidth(){return this.getAttribute(e.MAX_WIDTH)}set lineClamp(t){t?(this.setAttribute(e.LINE_CLAMP,`${t}`),this.container?.style.setProperty("-webkit-line-clamp",`${t}`),this.container?.classList.add("has-line-clamp")):(this.removeAttribute(e.LINE_CLAMP),this.container?.style.removeProperty("-webkit-line-clamp"),this.container?.classList.remove("has-line-clamp"))}get lineClamp(){return this.getAttribute(e.LINE_CLAMP)}set overflow(t){t==="ellipsis"?(this.container?.classList.add("ellipsis"),this.setAttribute("overflow","ellipsis")):(this.container?.classList.remove("ellipsis"),this.removeAttribute("overflow"))}get overflow(){return this.getAttribute("overflow")}set textAlign(t){this.container?.classList.remove(...this.textAlignClass(!0)),w.includes(t)?(this.setAttribute(e.TEXT_ALIGN,t),this.container?.classList.add(this.textAlignClass())):this.removeAttribute(e.TEXT_ALIGN)}get textAlign(){return this.getAttribute(e.TEXT_ALIGN)??""}textAlignClass(t){let s=i=>`text-align-${i}`;return t?w.map(i=>s(i)):s(this.textAlign)}set status(t){this.container?.classList.remove(...this.statusClass(!0)),C.includes(t??"")?(this.setAttribute(e.STATUS,t??""),this.container?.classList.add(this.statusClass())):this.removeAttribute(e.STATUS)}get status(){return this.getAttribute(e.STATUS)}statusClass(t){let s=i=>`status-${i}`;return t?C.map(i=>s(i)):s(this.status??"")}set translateText(t){let s=r(t);s&&!this.getAttribute("translation-key")&&(this.setAttribute(e.TRANSLATE_TEXT,s.toString()),o(this,n,d).call(this))}get translateText(){return r(this.getAttribute(e.TRANSLATE_TEXT))}canTooltipShow(){return this.tooltip&&this.tooltip!=="false"&&this.container&&(u(this.container)||u(this.parentElement))||!1}};c=new WeakSet,I=function(){this.translateText&&(this.onLanguageChange=async()=>{await o(this,n,d).call(this)},this.setAttribute("translation-key",this.textContent??""),o(this,n,d).call(this))},h=new WeakSet,S=function(t){this.container?.classList.remove(...y),y.includes(t)&&this.container?.classList.add(t)},n=new WeakSet,d=async function(){let t=this.getAttribute("translation-key");!this.localeAPI||!t||(this.textContent=this.localeAPI.translate(t))},a=b([g("ids-text"),f(T)],a);export{a};
